module.exports = __webpack_public_path__ + "static/media/sound5.eec24e6e.mp3";